/* CHATS */
export const REQUEST_CONFIRMATION = "REQUEST_CONFIRMATION"
export const CANCEL_CONFIRMATION = "CANCEL_CONFIRMATION"
export const CONFIRM = "CONFIRM"
